import { enumFillMode } from "../constants";

export function QColorPickerResult() {
  this.fFillMode = enumFillMode.solidFill;
  this.fSelectedColor = "#FFFFFF";
  this.fSelectedColor2 = "#FFFFFF";
  this.fReturn = null;
}
